/*
 * @Author: wangzhenxin wangzhenxin@juneyaoair.com
 * @Date: 2022-08-30 18:17:28
 * @LastEditors: wangzhenxin wangzhenxin@juneyaoair.com
 * @LastEditTime: 2022-10-13 17:45:57
 * @FilePath: /ijx-portal-app-front/src/router/module/not-read.map.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const notRead = r => require.ensure([], () => r(require('@/views/not-read/not-read.vue'), 'notRead')) // 未读路由
// 路由组件注册
const router = [
  {
    path: '/notRead',
    name: 'notRead',
    meta: {
      title: '未读文章'
    },
    component: notRead
  }
]

export default router
